module.exports = __webpack_public_path__ + "img/bear5.dda4e731.svg";